import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default function Hero() {
  const sceneRef = useRef(null);

  useEffect(() => {
    const tl = gsap.timeline({ delay: 0.2 });
    tl.from('#hBadge',  { opacity:0, y:20, duration:.65, ease:'power3.out' })
      .from('#hw1', { opacity:0, y:44, duration:.6,  ease:'power3.out' }, '-=.2')
      .from('#hw2', { opacity:0, scale:.6, duration:.55, ease:'back.out(2.2)' }, '-=.28')
      .from('#hw3', { opacity:0, scale:.6, duration:.55, ease:'back.out(2.2)' }, '-=.38')
      .from('#hw4', { opacity:0, x:20, duration:.45, ease:'power3.out' }, '-=.3')
      .from('#hw5', { opacity:0, y:30, duration:.6,  ease:'power3.out' }, '-=.3')
      .from('#hSub',  { opacity:0, y:20, duration:.65, ease:'power3.out' }, '-=.22')
      .from('#hBtns', { opacity:0, y:20, duration:.6,  ease:'power3.out' }, '-=.38')
      .from('#hStats',{ opacity:0, y:20, duration:.55, ease:'power3.out' }, '-=.32')
      .from(['#fc1','#fc2','#fc3','#fc4'], { opacity:0, scale:.8, y:32, stagger:.13, duration:.8, ease:'back.out(1.5)' }, '-=.32')
      .from('.c-orb', { opacity:0, scale:.3, duration:1.1, ease:'elastic.out(1,.5)' }, '-=.45')
      .from('.cta-c', { opacity:0, scale:.5, duration:.55, ease:'back.out(2)' }, '-=.2');

    const countUp = (el, end) => {
      if (!el) return;
      let n = 0;
      const step = () => { n = Math.min(n + Math.ceil((end-n)/8)+1, end); el.textContent = n; if(n<end) requestAnimationFrame(step); };
      step();
    };
    ScrollTrigger.create({ trigger:'#hStats', start:'top 85%',
      onEnter: () => {
        setTimeout(() => countUp(document.getElementById('sC'), 500), 200);
        setTimeout(() => countUp(document.getElementById('sP'), 1000), 400);
      }
    });

    let mx=0,my=0,ptx=0,pty=0;
    const onMove = e => { mx=(e.clientX/window.innerWidth-.5)*14; my=(e.clientY/window.innerHeight-.5)*10; };
    document.addEventListener('mousemove', onMove);
    let raf;
    const par = () => {
      ptx += (mx-ptx)*.055; pty += (my-pty)*.055;
      if(sceneRef.current) sceneRef.current.style.transform = `rotateY(${ptx*.38}deg) rotateX(${-pty*.27}deg)`;
      raf = requestAnimationFrame(par);
    };
    par();

    document.querySelectorAll('.fc').forEach(card => {
      card.addEventListener('mousemove', e => {
        const r = card.getBoundingClientRect();
        gsap.to(card, { rotateY:(e.clientX-r.left)/r.width*12-6, rotateX:-((e.clientY-r.top)/r.height*12-6), duration:.35, ease:'power2.out', transformPerspective:800 });
      });
      card.addEventListener('mouseleave', () => gsap.to(card, { rotateY:0, rotateX:0, duration:.7, ease:'power2.out' }));
    });

    document.querySelectorAll('a[href^="#"]').forEach(a => {
      a.addEventListener('click', e => {
        const target = document.querySelector(a.getAttribute('href'));
        if (!target) return;
        e.preventDefault();
        const top = target.getBoundingClientRect().top + window.scrollY - 80;
        window.scrollTo({ top, behavior: 'smooth' });
      });
    });

    return () => {
      document.removeEventListener('mousemove', onMove);
      cancelAnimationFrame(raf);
    };
  }, []);

  const GoogleIcon = () => (
    <svg viewBox="0 0 24 24">
      <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
      <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
      <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05"/>
      <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
    </svg>
  );

  return (
    <section className="hero" id="hero">
      <div className="blob b1" /><div className="blob b2" /><div className="blob b3" />
      <div className="dot-g" />
      <div className="hero-in">

        {/* LEFT */}
        <div className="hl">
          {/* <div className="h-badge" id="hBadge">
            <div className="bdot" />
            <span>Verified Client Reviews</span>
          </div> */}

          <h1 className="h-title">
            <span className="hw"><span id="hw1">Over 10 Years of</span></span>
            <span className="hw"><span id="hw2" className="pill p-red">Delivering</span></span>
            <span className="hw">
              <span id="hw3" className="pill p-purple">High-End</span>
              <span id="hw4"> Software</span>
            </span>
            <span className="hw"><span id="hw5" className="grad-txt">Development Services</span></span>
          </h1>

          <p className="h-sub" id="hSub">
            Real reviews from real clients who trusted <strong>KodersPedia</strong> to build their websites, mobile apps, software products, and digital solutions — delivered on time, every time.
          </p>

          <div className="h-btns" id="hBtns">
            <a href="#google" className="btn-main">
              <span>Read Reviews</span>
              <span className="ic">
                <svg width="13" height="13" viewBox="0 0 14 14" fill="none"><path d="M2 7h10M7 3l4 4-4 4" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
              </span>
            </a>
            <a href="https://koderspedia.com/" className="btn-ghost" target="_blank" rel="noopener noreferrer"><span>Visit KodersPedia ↗</span></a>
          </div>

          <div className="h-stats" id="hStats">
            <div className="hs">
              {/* <div className="hs-stars">★★★★★</div> */}
              <div className="hs-val">4.9</div>
              <div className="hs-label">Avg Rating</div>
            </div>
            <div className="hs">
              <div className="hs-val"><span className="hs-acc" id="sC">500</span>+</div>
              <div className="hs-label">Happy Clients</div>
            </div>
            <div className="hs">
              <div className="hs-val"><span className="hs-acc" id="sP">1000</span>+</div>
              <div className="hs-label">Projects Done</div>
            </div>
          </div>
        </div>

        {/* RIGHT 3D */}
        <div className="hr">
          <div className="scene" id="scene" ref={sceneRef}>
            <span className="fs fs1">★</span>
            <span className="fs fs2">★</span>
            <span className="fs fs3">★</span>
            <div className="nline nl-v" /><div className="nline nl-h" />

            {/* TOP ROW */}
            <div className="mob-row mob-row-top">
              <div className="fc fc-g fc1" id="fc1">
                <div className="fc-top">
                  <span className="pchip pg"><GoogleIcon /> Google</span>
                  <span className="r-pill">5.0 ★</span>
                </div>
                <div className="fc-stars">★★★★★</div>
                <div className="fc-text">"Delivered our platform ahead of schedule. Exceptional code quality throughout."</div>
                <div className="fc-author"><div className="av av-b">MT</div><div><div className="fc-nm">Marcus T.</div><div className="fc-role">CEO, RetailFlow Inc.</div></div></div>
              </div>
              <div className="fc fc-c fc2" id="fc2">
                <div className="fc-top">
                  <span className="pchip pc">
                    <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="11" fill="#D93025"/><text x="7.5" y="17" fontSize="13" fontWeight="900" fill="white" fontFamily="Arial">C</text></svg> Clutch
                  </span>
                  <span className="r-pill">5.0 ★</span>
                </div>
                <div className="fc-stars">★★★★★</div>
                <div className="fc-text">"React Native app launched to 50K users — zero bugs on day one. Incredible team."</div>
                <div className="fc-author"><div className="av av-r">PS</div><div><div className="fc-nm">Priya S.</div><div className="fc-role">Product Lead, AppVentures</div></div></div>
              </div>
            </div>

            {/* CENTER ORB */}
            <div className="c-orb">
              <div className="orb-ring">
                <div className="orb-num">4.9</div>
                <div className="orb-stars">★★★★★</div>
                <div className="orb-sub">Overall</div>
              </div>
            </div>

            {/* BOTTOM ROW */}
            <div className="mob-row mob-row-bot">
              <div className="fc fc-y fc3" id="fc3">
                <div className="fc-top">
                  <span className="pchip py">
                    <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="11" fill="#C41200"/><text x="8" y="17" fontSize="14" fontWeight="900" fill="white" fontFamily="Arial">y</text></svg> Yelp
                  </span>
                  <span className="r-pill">5.0 ★</span>
                </div>
                <div className="fc-stars">★★★★★</div>
                <div className="fc-text">"Transformed our restaurant's entire digital presence. Truly professional team."</div>
                <div className="fc-author"><div className="av av-p">DR</div><div><div className="fc-nm">Daniel R.</div><div className="fc-role">Owner, Bella Cucina</div></div></div>
              </div>
              <div className="fc fc-t fc4" id="fc4">
                <div className="fc-top">
                  <span className="pchip pt">
                    <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="11" fill="#00B67A"/><polygon points="12,6 13.5,10.5 18,10.5 14.5,13 15.5,17.5 12,15 8.5,17.5 9.5,13 6,10.5 10.5,10.5" fill="white"/></svg> Trustpilot
                  </span>
                  <span className="r-pill">5.0 ★</span>
                </div>
                <div className="fc-stars">★★★★★</div>
                <div className="fc-text">"Staff aug team integrated seamlessly. Completely transformed our product."</div>
                <div className="fc-author"><div className="av av-g">SK</div><div><div className="fc-nm">Sarah K.</div><div className="fc-role">CTO, NovaTech</div></div></div>
              </div>
            </div>

            <a href="#google" className="cta-c">
              <div className="cta-spin">
                <svg viewBox="0 0 100 100">
                  <defs><path id="cp" d="M50,50 m-38,0 a38,38 0 1,1 76,0 a38,38 0 1,1 -76,0"/></defs>
                  <text><textPath href="#cp" startOffset="0%">READ REVIEWS • KODERSPEDIA •</textPath></text>
                </svg>
              </div>
              <div className="cta-btn">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M3.5 9H14.5M14.5 9L9.5 4M14.5 9L9.5 14" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
